import { createContext, useContext } from "react";
import { BlockState, DispatchAction } from "../Common";
import { useImmerReducer } from "use-immer";


const BlockSumToInitialState:BlockState={
    isError:false,
    CurrentSumToValue:0,
    currentIndex:0,
    resetFocus : true
}

function BlockSumToReducer(draft: BlockState, action: DispatchAction) {
    switch (action.type) {
      case "UpdateSumToValue":
        draft.CurrentSumToValue = action.value;
        break;
      case "BlockError":
        draft.isError = action.value  
        break;
      case "UpdateIndex":
        draft.currentIndex = action.value  
        break;  
      case "ResetCommandIndexFocus":
          draft.resetFocus = action.value  
          break;         
      default:
        console.log("Unknown Action value:"+action.type)
        break;
    }
  }

export const BlockContext = createContext(BlockSumToInitialState);

export const BlockDispatchContext = createContext<React.Dispatch<DispatchAction>>(() => { });

export function BlockContextProvider({ children }: any) {

    const [state, dispatch] = useImmerReducer(BlockSumToReducer, BlockSumToInitialState);

  
    return (
      <BlockContext.Provider value={state}>
        <BlockDispatchContext.Provider value={dispatch}>
          {children}
        </BlockDispatchContext.Provider>
      </BlockContext.Provider>
    );
  }
  
  export function useBlockCtx() {
    return useContext(BlockContext);
  }
  
  export function useBlockDispatchCtx() {
    return useContext(BlockDispatchContext);
  }
  
